<template>
  <!-- <el-card class="elshadow">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="date" label="Date" width="180"> </el-table-column>
      <el-table-column prop="name" label="Name" width="180"> </el-table-column>
      <el-table-column prop="address" label="Address"> </el-table-column>
    </el-table>
  </el-card> -->
  <div class="bg-white rounded-10px elshadow w-full p-6">
    <ListComponents />
    <div class="grid grid-cols-3 gap-2 w-full">
      <div
        class="p-5"
        :class="{
          'bg-light-green': row.status.status === 'Completed',
          'bg-f4f5f6': row.status.status === 'Not Started',
          'bg-light-orange': row.status.status === 'WIP',
        }"
        v-for="row in tasks"
        :key="row._id"
      >
        <div class="flex items-center gap-2">
          <p class="text-success text-sm font-semibold" v-if="row.role">
            {{ row.role.role }}
          </p>
          <p class="text-8f8f8f text-sm font-semibold" v-if="row.manHrs">
            {{ Number(row.manHrs).toFixed(2) }} ManHrs
          </p>
          <p class="text-8f8f8f text-sm font-semibold" v-else>0 ManHrs</p>
        </div>
        <div>
          <h6 class="text-black font-semibold text-lg mt-5" v-if="row.page">
            {{ row.page.page }}
          </h6>
          <p class="text-8f8f8f text-sm font-medium mt-1">
            {{ row.description }}
          </p>
          <p class="text-8f8f8f text-sm font-medium mt-1">
            {{ row.mobileTag ? row.mobileTag : "" }}
          </p>
        </div>
        <div class="mt-6">
          <div class=" ">
            <p
              class="bg-light-orange fsize10 w-24 h-8 rounded-full flex justify-center items-center font-semibold"
              v-if="row.status.status == 'WIP'"
            >
              Pending
            </p>
            <p
              class="text-fas flex justify-center fsize10 w-24 h-8 rounded-full items-center bg-glass fsize10 font-semibold"
              v-else
            >
              {{ row.status.status }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="whitenowrap mt-6 flex justify-end">
      <el-pagination
        @current-change="
          (value) => {
            currentPage = value;
            getUserStories();
          }
        "
        background
        layout="prev,pager,next"
        class="rem-nowrap"
        :total="countData"
        :page-size="perPage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import ListComponents from "./ListCompo.vue";

import Repository from "@/builder/apis/Repository";
import { mapState, mapGetters } from "vuex";
import alertMixin from "@/builder/mixins/alerts";
export default {
  mixins: [alertMixin],
  components: {
    ListComponents,
  },
  data() {
    return {
      countData: 0,
      perPage: 9,
      currentPage: 1,
      displayedData: [],
      optionsbadges: [
        { value: "A", text: "WIP" },
        { value: "B", text: "Not Started" },
        { value: "C", text: "Developed" },
        { value: "D", text: "Tested" },
      ],
      selectedbadge: "A",
      page: 1,
      offset: 0,
      limit: 10,
      loadData: false,
      taskList: [],
      tasks: [],
      filtered: [],
      wColumn: {
        filteredValue: [],
      }, // wireframeColumnAttributes
      webNoPreview: require("../../img/no-preview.png"),
      mobileNoPreview: require("../../img/no-preview-mobile.png"),
      editTaskPopup: false,
      editTaskSelected: "",
      edit: {},
      editClicked: false,
      allTasks: [],
      userStoriesFile: "",
      components: [],
    };
  },

  watch: {
    selectedComponent() {
      this.getUserStories();
      // this.allTasks = this.selectedSprintStories;
    },
    setselectedroles() {
      this.getUserStories();
    },
    setStoriesType() {
      this.getUserStories();
    },
    selectedMobileTag() {
      this.getUserStories();
    },
    // firstColLabel() {
    //   this.$refs.tableContainer.clearFilter();
    // },
  },

  methods: {
    editClick(item, val) {
      item.editClicked = val;
      if (val === true) {
        this.edit = { ...item };
      } else {
        item.description = this.edit.description;
      }
    },

    handleRoute(route, item, platform) {
      if (route === "wireframe") {
        // const story = this.selectedComponent;
        // this.$store.commit("design/SET_SELECTED_STORY", story);
        this.$store.commit(
          "design/SET_DESIGN_PLATFORM",
          platform ? platform : "Web"
        );
        //let allWireframes = [];

        let allWireframes = this.components.map((element) => {
          let web = element.webWireframe.length
            ? element.webWireframe.map((el) => {
                return { name: element.name, web: el };
              })
            : [{ name: element.name, web: "" }];
          return web;
        });

        // let allWireframes = this.selectedComponent.
        // console.log(
        //   allWireframes.flat().map((el, index) => {
        //     return { name: el.name, web: el.web, mobile: el.mobile, index };
        //   })
        // );
        this.$store.commit(
          "design/SET_ALL_IMAGES",
          allWireframes.flat().map((el, index) => {
            return { name: el.name, wireframe: el.web, index };
          })
        );
      }
      this.$router.push({ name: route });
    },

    filterHandler(value, row, column) {
      try {
        // console.log(row[value]);
        // this.wColumn = { ...column };
        if (row[value]) {
          return row[value];
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getTaskList() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Repository.post(
            "/zoho/projects/tasks/tasklist"
          );

          this.taskList = data.data.map((x) => ({
            text:
              x.name == "Sprint 0" || x.name == "Version 0"
                ? "Default"
                : x.name,
            value: x,
          }));

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },

    requirements() {
      this.$router.push({ name: "requirements" });
    },

    testcases() {
      this.$router.push({ name: "testcases" });
    },
    defecttracker() {
      this.$router.push({ name: "defecttracker" });
    },
    async getUserStories() {
      // let loader = this.$loading.show({});
      return new Promise(async (resolve, reject) => {
        try {
          this.tasks = [];
          const payload = {
            projectName: this.selectedProject.projectName,
            tasklistID: this.selectedSprint._id,
            paginated: true,
            limit: this.perPage,
            assigneeStatuses: ["WIP", "Not Started"],
          };
          if (this.currentPage == 1) {
            Object.assign(payload, { offset: this.perPage - 9 });
          } else {
            Object.assign(payload, {
              offset: this.perPage * (this.currentPage - 1),
            });
          }
          if (
            this.selectedComponent &&
            this.selectedComponent.hasOwnProperty("pageId")
          ) {
            Object.assign(payload, { pageID: this.selectedComponent.pageId });
          }
          if (this.setselectedroles.hasOwnProperty("roleId")) {
            Object.assign(payload, { roleID: this.setselectedroles.roleId });
          }
          if (this.setStoriesType) {
            Object.assign(payload, { storiesType: this.setStoriesType });
          }
          if (this.setStoriesType === "Mobile") {
            Object.assign(payload, { mobileTag: this.selectedMobileTag });
          }

          console.log("this is execute");
          const { data } = await this.$store.dispatch(
            "builder/getProjectUserStories",
            payload
          );
          console.log(data);
          this.tasks = data.data.map((x) => ({ ...x, editClicked: false }));
          this.countData = data.count;
          // loader.close();
          resolve(data);
        } catch (error) {
          // loader.close();
          reject(error);
        }
      });
    },

    handleClick(item) {
      this.$store.commit("design/SET_SELECTED_STORY", item);
      this.$router.push({ name: "wireframe" });
    },

    async sprintSelected() {
      try {
        await this.$store.commit("design/SET_SELECTED_SPRINT", this.selected);
      } catch (error) {
        console.log(error);
      }
    },

    async strikeTask(item) {
      if (this.selectedSprint.milestone != "Analysis") {
        this.$swal({
          text: `Snap! We've restricted deleting of scope since it has already been moved to the U/X Team. This helps us maintain sanctity of the project. However, if you still wish to delete, you may initiate a new scope by clicking on "New Requirement" button and share your changes. By doing this, we ensure detailed impact analysis for the suggested change before taking it forward.`,
          icon: "info",
        });
      } else {
        if (item.isStriked == true) {
          item.isStriked = false;
        } else item.isStriked = true;
        item.username = this.brainedUserDetails.username;
        item.action = "Task Deleted";
        await Repository.post("/zoho/projects/tasks/updateTask", item);
        // if (item.BA_status == "Approved") {
        //   await this.updateStatus(item);
        // }
      }
    },

    async editTask(row) {
      if (this.selectedSprint.milestone != "Analysis") {
        this.$swal({
          text: `Snap! We've restricted editing of scope since it has already been moved to the U/X Team. This helps us maintain sanctity of the project. However, if you still wish to make an edit, you may initiate a new scope by clicking on "New Requirement" button and share your changes. By doing this, we ensure detailed impact analysis for the suggested change before taking it forward.`,
          icon: "info",
        });
      } else {
        this.editTaskSelected = { ...row };
        await this.taskEdited();
        row.editClicked = false;
      }
    },

    async taskEdited() {
      let loader = this.$loading.show({});
      try {
        this.editTaskSelected.username = this.brainedUserDetails.username;
        this.editTaskSelected.action = "Edit Task";
        const { data } = await Repository.post(
          "/zoho/projects/tasks/updateTask",
          this.editTaskSelected
        );
        this.tasks
          .filter((x) => x.name === this.editTaskSelected.name)
          .forEach((e) => {
            e.version = this.editTaskSelected.version;
          });
        const index = this.tasks.findIndex(
          (x) => x._id === this.editTaskSelected._id
        );

        this.tasks[index].isEdited = true;
        this.tasks[index].description = this.editTaskSelected.description;
        this.tasks[index].ba_history = data.data.ba_history;
        if (this.editTaskSelected.BA_status == "Approved") {
          await this.updateStatus(this.editTaskSelected);
        }
        loader.hide();
      } catch (error) {
        loader.hide();
      }
    },

    async updateStatus(item) {
      return new Promise(async (resolve, reject) => {
        let loader = this.$loading.show({});
        try {
          const index = this.tasks.findIndex((x) => x._id === item._id);
          const index1 = this.allTasks.findIndex((x) => x._id === item._id);
          item.bucketName = "BA";

          const { data } = await Repository.post(
            "/zoho/projects/tasks/TaskStatus",
            {
              ...item,
              user: this.brainedUserDetails.username,
            }
          );

          this.tasks[index].BA_status = data.data.BA_status;
          this.allTasks[index1].BA_status = data.data.BA_status;
          resolve();
          loader.hide();
        } catch (error) {
          loader.hide();
          reject(error);
        }
      });
    },

    setButtonText(text) {
      switch (text) {
        case "Approved":
          return "Reviewed";

        case "Unapprove":
          return "Unread";

        case "Under Review":
          return this.isClient ? "Approve" : "Pending Review";

        default:
          return text;
      }
    },

    async submitForReview(item) {
      return new Promise(async (resolve, reject) => {
        let loader = this.$loading.show({});
        try {
          await Repository.post("/zoho/projects/tasks/submitForReview", {
            _id: item._id,
            desk: {
              appName: this.selectedProject.projectName,
              version: this.selectedSprint.name,
              username: this.brainedUserDetails.username,
            },
          });
          this.$swal({
            text: "Your request has been sent. Your Business Analyst will respond within 24 hours.",
            icon: "success",

            confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });

          await this.getUserStories(item);

          resolve();
          loader.hide();
        } catch (error) {
          loader.hide();
          reject(error);
        }
      });
    },

    async handleReviewAll(item) {
      try {
        const result = await this.confirmAlert(
          "Are you sure you want to mark all user stories as reviewed?"
        );
        if (result.isConfirmed) {
          this.reviewAll(item);
        }
      } catch (error) {
        reject(error);
      }
    },

    async reviewAll(item) {
      return new Promise(async (resolve, reject) => {
        let loader = this.$loading.show({});
        try {
          let condition = {};
          switch (item.milestone) {
            case "Analysis":
              condition = {
                taskListID: item._id,
                bucketName: "BA",
              };
              break;
            default:
              break;
          }

          const data = await Repository.post(
            "zoho/projects/tasks/reviewTasks",
            condition
          );
          await this.$store.commit(
            "design/SET_SELECTED_COMPONENT",
            this.selectedComponent
          );
          this.allTasks.map((x) => (x.BA_status = "Approved"));
          resolve(data);
          loader.hide();
        } catch (error) {
          reject(error);
          loader.hide();
        }
      });
    },

    async handleSignoff(data) {
      if (this.selectedSprint.milestone == "Analysis") {
        const nonApprovedTasks = this.allTasks.filter(
          (x) => x.BA_status !== "Approved" && !x.isStriked
        );
        const currentVersion = this.selectedSprint;

        const version = currentVersion.name.replace(/\D/g, "");
        const hasCustomTasksInCurrentVersion = this.allTasks.filter(
          (x) => x.type === "Custom" && x.version == version
        );
        if (
          currentVersion.requirement &&
          !hasCustomTasksInCurrentVersion.length
        ) {
          this.$swal({
            text: "The Business Analyst is still analysing your requirement. You can't Sign Off at this moment",
            icon: "info",
          });
        } else if (!nonApprovedTasks.length) {
          const result = await this.confirmAlert(
            "Are you sure you want to Sign off on Analysis? Ensure your requirements are accurate! By clicking on Sign off, you will no longer be able to change the requirement. "
          );
          if (result.isConfirmed) {
            this.signOff(data);
          }
        } else {
          this.signOff(data);
        }
      } else {
        alert("UX signoff");
      }
    },

    async signOff(data) {
      return new Promise(async (resolve, reject) => {
        let loader = this.$loading.show({});
        try {
          const nonApprovedTasks = this.allTasks.filter(
            (x) => x.BA_status !== "Approved" && !x.isStriked
          );

          if (nonApprovedTasks.length) {
            this.$swal({
              text: "The status of all the user stories should be Reviewed in order to proceed.",
              icon: "info",

              confirmButtonColor: "#830c81",
              // cancelButtonColor: "#d33",
              confirmButtonText: "OK",
            });
          } else {
            await Repository.post("/zoho/projects/tasks/updateTaskList", {
              _id: data._id,
              update: {
                BA_signOff_status: {
                  status: true,
                  name: this.brainedUserDetails.username,
                },
                milestone: "Design",
              },
              team: "U/X Designer",

              desk: {
                appName: this.selectedProject.projectName,
                username: this.brainedUserDetails.username,
                sprintName: data.name,
              },
            });
            const index = this.taskList.findIndex((x) => x._id === data._id);
            if (index !== -1) {
              this.taskList[index].milestone = "Design";
            }

            this.$swal({
              text: "Your requirements have been submitted to the UI/UX Designer.",
              icon: "success",

              confirmButtonColor: "#830c81",
              // cancelButtonColor: "#d33",
              confirmButtonText: "OK",
            }).then(() => {
              this.$store.commit("user/SET_LATEST_MILESTONE", "Design");
              // this.$router.push({ name: "ux" });a
            });
          }

          loader.hide();
        } catch (error) {
          loader.hide();
          reject(error);
        }
      });
    },

    async init() {
      // await this.getTaskList();
      // if (Object.keys(this.selectedSprint).length) {
      //   const index = this.taskList.findIndex(
      //     x => x.value._id === this.selectedSprint._id
      //   );
      //   this.selected =
      //     index > -1 ? this.selectedSprint : this.taskList[0].value;
      // } else {
      //   this.selected = this.taskList[0].value;
      // }
      // await this.$store.commit("design/SET_SELECTED_SPRINT", this.selected);
      // await this.getPages();
      await this.getUserStories(this.selectedComponent._id);
      this.allTasks = this.selectedSprintStories;
    },

    imageUrl(row) {
      return `${this.$imageURL}/${row}`;
    },

    // downloadExcel(team) {
    //   import("@/plugins/Export2Excel").then((excel) => {
    //     let list = [];
    //     let headers = [];
    //     let filename = [];

    //     switch (team) {
    //       case "isBusinessAnalyst":
    //         list = [];
    //         headers = ["page", "name", "suiteOrExtensionName", "description"];
    //         filename = "user stories";
    //         break;

    //       case "isUX":
    //         list = this.tickets.map((x) => ({
    //           ticket: x,
    //           web: "",
    //           mobile: "",
    //         }));
    //         headers = ["ticket", "web", "mobile"];
    //         filename = "ux design";
    //         break;

    //       default:
    //         break;
    //     }

    //     // const list = [];
    //     // const headers = ["page", "name", "suiteOrExtensionName", "description"];
    //     const data = this.formatJson(headers, list);
    //     excel.export_json_to_excel({
    //       header: headers,
    //       data,
    //       filename: filename,
    //       autoWidth: true,
    //       bookType: "csv",
    //     });
    //   });
    // },

    // formatJson(filterVal, jsonData) {
    //   return jsonData.map((v) =>
    //     filterVal.map((j) => {
    //       return v[j];
    //     })
    //   );
    // },

    async upload() {
      return new Promise(async (resolve, reject) => {
        let loader = this.$loading.show({});
        try {
          const formData = new FormData();
          formData.append("tasks", this.userStoriesFile);
          formData.append("username", this.brainedUserDetails.username);
          const data = await Repository.post(
            "/zoho/projects/tasks/bulkInsertTask",
            formData
          );

          // await this.getTasks(this.selectedSprint);
          this.userStoriesFile = "";
          this.$refs.fileUpload.reset();
          await this.getPages();
          loader.hide();
          resolve(data);
        } catch (error) {
          this.$swal({
            text: "Something went wrong",
            icon: "error",
          });
          reject(error);
          console.log(error);
          loader.hide();
        }
      });
    },

    async uploadFile(e) {
      this.userStoriesFile = e.target.files[0];
      await this.upload();
    },

    async getAllComponents() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Repository.post(
            "zoho/projects/tasks/components",
            {
              tasklistID: this.selectedSprint._id,
            }
          );
          this.components = data.data.map((x) => ({ ...x, Hrs: 0 }));
          this.$store.commit(
            "design/SET_SELECTED_COMPONENT",
            this.components[0]
          );
          resolve("Yes");
        } catch (error) {
          reject(error);
        }
      });
    },

    async getPages() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Repository.post(
            "uibuilder/getPages",
            {
              projectId: this.selectedProject._id,
              projectName: this.selectedProject.projectName,
              tasklistID: this.selectedSprint._id,
            },
            {
              headers: {
                "community-name": this.selectedProject.projectName,
              },
            }
          );
          console.log(data, "pages");
          this.components = data.data.map((x) => ({ ...x, Hrs: 0 }));
          // this.$store.commit("design/SET_COMPONENTS", data.data);
          // this.$store.commit(
          //   "design/SET_SELECTED_COMPONENT",
          //   this.components[0]
          // );
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  computed: {
    firstColLabel() {
      return `${this.selectedComponent.name} User Stories`;
    },
    ...mapState("design", [
      "selectedSprint",
      "selectedComponent",
      "setselectedroles",
      "setStoriesType",
      "selectedSprintStories",
      "selectedMobileTag",
    ]),
    ...mapState("user", ["brainedUserDetails", "selectedProject"]),
    ...mapGetters("user", {
      isBusinessAnalyst: "isBusinessAnalyst",
      isClient: "isClient",
      isUX: "isUX",
    }),
    canApprove() {
      return (text) => {
        switch (text) {
          case "Approved":
            return false;

          case "Unapprove":
            return this.isClient;

          case "Under Review":
            return this.isClient;

          default:
            return false;
        }
      };
    },

    hasUnapprovedTasks() {
      return this.allTasks.filter((x) => x.BA_status === "Unapprove").length;
    },
    canSignoff() {
      return this.allTasks.filter((x) => x.BA_status !== "Approved").length;
    },

    signOffText() {
      switch (this.selectedSprint.milestone) {
        case "Analysis":
          return "Sign Off on Analysis";
          break;
        case "Design":
          return "Sign Off on UX";
          break;
        case "Development":
          return "Sign Off on Development";
          break;
        default:
          break;
      }
    },

    tickets() {
      return this.tasks.map((x) => x.ticketID);
    },
  },

  async mounted() {
    // await this.init();
    await this.getUserStories;
    // await this.getUserStoriesOnMount();
    // console.log(this.tasks[0].manHrs);
  },
};
</script>
